import React from 'react';
import withRouter from '../Components/Common/withRouter';

//import Components
import Header from "Layouts/Header";
import Footer from "Layouts/Footer";
import MobileMenu from "Layouts/MobileMenu";

const NonAuthLayout = ({ children } : any) => {

    document.documentElement.setAttribute('data-layout', 'horizontal');
    
    return (
        <React.Fragment>
        <div id="layout-wrapper">
          <Header headerclassName={"topbar-shadow"} />
          <MobileMenu />
          {children}
          <Footer />
        </div>
        </React.Fragment>
    );
};

export default withRouter(NonAuthLayout);